import POIStep from "@/components/POI/POIStep/POIStep.vue";

export default {
  name: "License",
  props: ["editedItem", "step", "position", "isOwnedBySubPrincipal"],
  components: { POIStep },
  data: () => ({
    // TODO: Ganz dringend in die DB verschieben
    licenseTypes: [
      {
        id: "CC-BY",
        label: "CC BY",
        requires: ["author"],
        info:
          "Diese Lizenz erlaubt Dritten, ein Werk zu verbreiten, zu remixen, " +
          "zu verbessern und darauf aufzubauen, auch kommerziell, solange der Urheber des Originals genannt wird."
      },
      {
        id: "CC-BY-SA",
        label: "CC BY SA",
        requires: ["author"],
        info:
          "Diese Lizenz erlaubt es Dritten, ein Werk zu verbreiten, zu remixen, zu verbessern und darauf " +
          "aufzubauen, auch kommerziell, solange der Urheber des Originals genannt wird und die auf seinem " +
          "Werk basierenden neuen Werke unter denselben Bedingungen veröffentlicht werden."
      },
      {
        id: "CC-BY-ND",
        label: "CC BY ND",
        requires: ["author"],
        info:
          "Diese Lizenz erlaubt Dritten die Weiterverbreitung des Werkes, kommerziell wie nicht-kommerziell, " +
          "solange dies ohne Veränderungen und vollständig geschieht und der Urheber genannt wird."
      },
      {
        id: "CC-BY-NC",
        label: "CC BY NC",
        requires: ["author"],
        info:
          "wie CC BY – zusätzlich mit der Einschränkung „nur nicht kommerziell“"
      },
      {
        id: "CC-BY-NC-SA",
        label: "CC BY NC SA",
        requires: ["author"],
        info:
          "wie CC BY SA – zusätzlich mit der Einschränkung „nur nicht kommerziell“"
      },
      {
        id: "CC-BY-NC-ND",
        label: "CC BY NC ND",
        requires: ["author"],
        info:
          "wie CC BY ND – zusätzlich mit der Einschränkung „nur nicht kommerziell“"
      },
      {
        id: "CC0",
        label: "CC0",
        requires: [],
        info: "Verzicht auf alle urheberrechtlichen und verwandten Schutzrechte"
      },
      {
        id: "PD",
        label: "Public Domain (gemeinfrei)",
        requires: [],
        info:
          "Dieses Werk ist gemeinfrei. Das ursprüngliche Urheberrecht ist abgelaufen oder besteht nicht mehr (z. B. 70 Jahre nach dem Tod des Urhebers). Das Werk darf ohne Einschränkungen genutzt, vervielfältigt, verändert und auch kommerziell verwendet werden. Eine Namensnennung ist rechtlich nicht erforderlich. Hinweis: Dies ist keine Lizenz im engeren Sinne, sondern ein rechtlicher Status und einer CCO Lizenz gleichzusetzen."
      }
    ]
  }),

  methods: {
    changeStep(position) {
      this.$emit("changeStep", position);
    }
  },
  computed: {
    selectedLicense() {
      return (
        this.licenseTypes.find(lt => lt.id === this.editedItem.license.type) ??
        {}
      );
    }
  }
};
